import React from 'react';


import { IsMobileProvider } from '../providers/is-mobile-provider';

import css from './base-layout.css';
import { Footer } from './footer';
import { Header } from './header';
import { PageErrorBoundary } from './page-error-boundary';

import type { PropsWithChildren } from 'react';

interface BaseLayoutProps extends PropsWithChildren {
  isMobile?: boolean;
  errorCode?: number;
}

export const BaseLayout = ({ children, errorCode, isMobile }: BaseLayoutProps) => {
  return (
    <PageErrorBoundary errorCode={errorCode}>
      <IsMobileProvider isMobile={isMobile}>
        <div className={css.wrapper}>
          <Header />
          <main className={css.main}>{children}</main>
          <Footer />
        </div>
      </IsMobileProvider>
    </PageErrorBoundary>
  );
};
